import React from 'react';
import PropTypes from 'prop-types';

const FlipSwitch = ({
  isOn,
  setIsOn,
  textLabel,
}) => (
  <div>
    <button
      type="button"
      className={isOn ? 'switch-background on' : 'switch-background off'}
      onClick={() => setIsOn(!isOn)}
    >
      <div className={isOn ? 'switch-on' : 'switch-off'}>
        <p style={{ margin: '0' }}>{textLabel}</p>
      </div>
    </button>
  </div>
);

FlipSwitch.propTypes = {
  isOn: PropTypes.bool,
  setIsOn: PropTypes.func.isRequired,
  textLabel: PropTypes.string,
};

FlipSwitch.defaultProps = {
  isOn: false,
  textLabel: '',
};

export default FlipSwitch;
